<template>
  <div></div>
</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRoute } from "vue-router";

export default {
  name: "SignupView",
  setup() {
    const { loginWithRedirect } = useAuth0();
    const route = useRoute();

    // Store intended destination so we return there after auth.
    // Supports ?returnTo=/some/path query parameter for deep linking.
    loginWithRedirect({
      appState: {
        target: route.query.returnTo || "/",
      },
      authorizationParams: {
        screen_hint: "signup",
      },
    });
  },
};
</script>
